var $ = require("jquery");
window.JQuery = $;
require("swiper");
require("./partials/_home");
require("./partials/_mail-list");
require("./partials/_product-navigator");
require("./partials/_products");
require("./partials/_products-landing");
require("./partials/_search-bar");
require("./partials/_recent-products");
require("./partials/_news");
require("./partials/_contact");
require("./partials/_cookies");
require("./partials/_analytics");
require("./partials/_category-view-more");



// WEBPACK FOOTER //
// ./assets/js/index.js